function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import React from 'react';
import ReactDOM from 'react-dom';
import CustomControl from '../components/Map/Controls/CustomControl';
import mapboxgl from '!mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
var addMapGeocoderControl = function addMapGeocoderControl(map, props, geocoderHandlers, accessToken, countries) {
  var markerElement = document.createElement('div');
  markerElement.className = 'marker';
  markerElement.style.width = '10px';
  markerElement.style.height = '10px';
  markerElement.style.borderRadius = '10px';
  markerElement.style.backgroundColor = '#ff1c67';
  var geocoder = new MapboxGeocoder({
    accessToken: accessToken,
    mapboxgl: mapboxgl,
    countries: countries !== null && countries !== void 0 ? countries : '',
    limit: 20,
    zoom: 13,
    marker: {
      element: markerElement
    }
  });

  //add geocoder event handler listeners
  for (var key in geocoderHandlers) {
    geocoder.on(key, geocoderHandlers[key]);
  }
  map.addControl(geocoder);
  //hide the default mapbox geocoder control
  var geocoderControlContainer = document.querySelector('.mapboxgl-ctrl-geocoder');
  if (geocoderControlContainer) {
    geocoderControlContainer.style.display = 'none';
  }
};
export var addMapControls = function addMapControls(parent, map, accessToken, geocoderEnabled, geocoderHandlers, geocoderCountries, props) {
  var navControl = new mapboxgl.NavigationControl({
    showCompass: false
  });
  map.addControl(navControl, 'bottom-right');
  if (geocoderEnabled) {
    addMapGeocoderControl(map, props, geocoderHandlers, accessToken, geocoderCountries);
  }
  var geolocateControl = new mapboxgl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true
    },
    trackUserLocation: true
  });
  map.addControl(geolocateControl, 'bottom-right');
  var homeControl = new CustomMapControl('home', parent, null, props, map);
  map.addControl(homeControl, 'bottom-right');
  var controls = {};
  ['top-left', 'top-right', 'bottom-left'].forEach(function (menuPosition) {
    var control = new CustomMapControl('menu', parent, "map-menu-container-" + menuPosition, props, map);
    controls[menuPosition] = control;
    map.addControl(control, menuPosition);
  });
};
export var removeMapCompasControl = function removeMapCompasControl(map, compassControl) {
  map.removeControl(compassControl);
};
export var addAttributionControl = function addAttributionControl(map) {
  map.addControl(new mapboxgl.AttributionControl({
    customAttribution: '<a href="https://vectuel.com/" target="_blank">&copy; Vectuel</a> '
  }));
};
export var addMapCompasControl = function addMapCompasControl(parent, props, map) {
  var compassControl = new CustomMapControl('compass', parent, null, props, map);
  map.addControl(compassControl, 'bottom-right');
  return compassControl;
};
var CustomMapControl = /*#__PURE__*/function () {
  function CustomMapControl(type, parent, className, initialOptions, map) {
    this.type = type;
    this.parent = parent;
    this.container = null;
    this.className = className;
    this.initialOptions = initialOptions;
    this.map = map;
  }
  var _proto = CustomMapControl.prototype;
  _proto._newDefaultComponent = function _newDefaultComponent() {
    return /*#__PURE__*/React.createElement(CustomControl, {
      type: this.type,
      map: this.map,
      initialOptions: this.initialOptions
    });
  };
  _proto.onAdd = function onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    var classNames = ['mapboxgl-ctrl', 'custom-map-control'];
    if (this.type === 'menu') {
      classNames.push('map-menu-container');
    } else if (this.type === 'main-menu') {
      classNames.push('main-layers-menu-container');
    }
    if (this.className) {
      classNames.push(this.className);
    }
    this.container.className = classNames.join(' ');
    var component = this.type === 'menu' || this.type === 'main-menu' ? null : this._newDefaultComponent();
    if (component) {
      try {
        ReactDOM.render(component, this.container);
      } catch (e) {
        console.log(e);
      }
    }
    return this.container;
  };
  _proto.onRemove = function onRemove() {
    if (this.container) {
      this.container.parentNode.removeChild(this.container);
    }
    this.map = undefined;
  };
  _createClass(CustomMapControl, [{
    key: "attached",
    get: function get() {
      return !!this.map;
    }
  }]);
  return CustomMapControl;
}();